/* unplugin-vue-components disabled */import { render } from "./evaluator.vue?vue&type=template&id=2386bea4&scoped=true&ts=true"
import script from "./evaluator.vue?vue&type=script&lang=ts"
export * from "./evaluator.vue?vue&type=script&lang=ts"

import "./evaluator.vue?vue&type=style&index=0&id=2386bea4&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2386bea4"]])

export default __exports__